import React, { useState } from 'react';
import './MeetTheTeam.css';

const MeetTheTeam = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  
  const teamMembers = [
    {
      id: 1,
      name: "Kounou Mawuena",
      role: "President",
      photo: "/team-pics/kounou-mawuena.jpg"
    },
    {
      id: 2,
      name: "Edem Noameshie",
      role: "General Secretary",
      photo: "/team-pics/edem-noameshie.jpg"
    },
    {
      id: 3,
      name: "Jocelyne Aba",
      role: "In Charge of Information",
      photo: "/team-pics/jocelyne-aba.jpg"
    },
    {
      id: 4,
      name: "Adjovi Akakpo",
      role: "Secretaire Adjointe",
      photo: "/team-pics/adjovi-akakpo.jpg"
    },
    {
      id: 5,
      name: "Francois Hoetowou",
      role: "Conseiller",
      photo: "/team-pics/francois-hoetowou.jpg"
    },
    {
      id: 6,
      name: "Jerry Ayanou",
      role: "Ajoint Trisorie",
      photo: "/team-pics/jerry-ayanou.jpg"
    },
    {
      id: 7,
      name: "Atisso Pascalle",
      role: "Treasurer"
    },
  ];

  return (
    <div className="meet-the-team">
      <section className="team-header">
        <div className="container">
          <h1>Meet Our Team</h1>
          <p className="team-subtitle">
            Dedicated leaders working together to strengthen our community
          </p>
        </div>
      </section>

      <section className="team-section">
        <div className="team-grid">
          {teamMembers.map(member => (
            <div key={member.id} className="team-card">
              {member.photo && (
                <div className="team-photo">
                  <img 
                    src={member.photo} 
                    alt={member.name} 
                    className="team-member-photo" 
                    onClick={() => setSelectedImage(member.photo)}
                  />
                </div>
              )}
              <div className="team-info">
                <h3>{member.name}</h3>
                <h4>{member.role}</h4>
              </div>
            </div>
          ))}
        </div>
      </section>
      
      {selectedImage && (
        <div className="modal-overlay" onClick={() => setSelectedImage(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setSelectedImage(null)}>×</button>
            <img src={selectedImage} alt="Team member" className="modal-image" />
          </div>
        </div>
      )}
    </div>
  );
};

export default MeetTheTeam;